import React,{useEffect,useState} from 'react';
import axios from 'axios';
import parse from 'html-react-parser';
import { instance } from './common';

function YakGawn({type}){

    const [data, setData] = useState('');
    
    useEffect(() => {
        const obj = {name:type};
        const fetchData = async () => {
            instance.post('/site_option/value',obj).then(function(res){
                setData(res.data.value);
            });
        
        };
    
        fetchData();
    }, []);

    const style = {
        overflow:'auto',
        height:'500px'
    }
  
    return (
        <div className="p-3" style={style}>
            {parse(data)}
        </div>
    )
}


export default YakGawn;